import {useState, useCallback} from 'react';

interface UseHoverStateReturn {
    hoveredRow: number | null;
    hoveredCol: number | null;
    handleCellHover: (rowIndex: number, colIndex: number) => void;
    handleMouseLeave: () => void;
    setHoveredRow: (row: number | null) => void;
    setHoveredCol: (col: number | null) => void;
}

export const useHoverState = (): UseHoverStateReturn => {
    const [hoveredRow, setHoveredRow] = useState<number | null>(null);
    const [hoveredCol, setHoveredCol] = useState<number | null>(null);

    const handleCellHover = useCallback((rowIndex: number, colIndex: number): void => {
        setHoveredRow(rowIndex);
        setHoveredCol(colIndex);
    }, []);

    const handleMouseLeave = useCallback((): void => {
        setHoveredRow(null);
        setHoveredCol(null);
    }, []);

    return {
        hoveredRow,
        hoveredCol,
        handleCellHover,
        handleMouseLeave,
        setHoveredRow,
        setHoveredCol,
    };
};
